import React, { useState } from 'react'
import LeafletForm from '../leaflet-form/leaflet-form'
import wpIco from '../../../shared/assets/images/whatsapp-icon.png'
import FormCodeVerification from '../form-code-verification/form-code-verification'
import FormLoyalty from '../form-loyalty/form-loyalty'
import WebinarService from '../../../shared/services/webinar'
import { secureStorage } from "../../../shared/state/utils/utilities-secure-storage";
import errorIcon from '../../../shared/assets/images/icon-advertencia.svg';
import GenericModalAlert from '../../../shared/components/molecules/generic-modal-alert/generic-modal-alert'
import InputWebinar from '../../atoms/input-webinar/input-webinar';
import Loader from 'react-loader-spinner'
import './form-webinar.scss'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode'
import RichText from "../../../shared/components/atoms/rich-text/rich-text"


const FormWebinar = props => {
    const { identificadorEvento, redireccionWhatsApp, webinarStatus, isPY, pyInfo, profesiones, isWomenWebinar, isSecondStyle,
        informacionSolicitudCertificado, informacionInicioConferencia, informacionInscripcionExitosa, informacionDescargaExitosa, informacionInscripcionConferencia, 
        checksAceptoDePoliticas } = props;
    const [stepState, setstepState] = useState(
        webinarStatus === 'En el Evento' ?
            'stepInEvent'
            :
            webinarStatus === 'Después del Evento' || webinarStatus === "Finalizado el Evento" ?
                'stepPostEvent'
                :
                'step1'
    )

    const EMAIL_RX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    const { homeLink } = useHomeLinkMode();

    const [userInfoPreload, setuserInfoPreload] = useState(null);
    const [isModalAlertVisible, setModalAlertVisibility] = useState(false)
    const [modalAlertText, setModalAlertText] = useState("")
    const [isLoaderVisible, setLoaderVisible] = React.useState(false);

    //Errors
    const [email, setemail] = useState('')
    const [emailError, setemailError] = useState(false)

    const retrygetCertificate = (_webinarId, _userId) => {
        let config = {
            responseType: 'blob'
        }
        WebinarService.getCertificate(_webinarId, _userId, config).then(resp => {
            if (resp.status === 200) {
                const file = new Blob([resp.data], { type: 'application/pdf' });
                const fileURL = window.URL.createObjectURL(file);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = fileURL;
                link.download = "Certificado.pdf";
                link.click();
            }
        })
            .catch(err => {
                let event = new CustomEvent("errorServiceModal", { "detail": 'Lo sentimos, tenemos un error generando el certificado, inténtalo de nuevo más tarde.' });
                document.dispatchEvent(event);
            })
    }

    const haveErrors = () => {
        if (!email) {
            setemailError('Debes llenar este campo')
        } else {
            if (!email.match(EMAIL_RX)) {
                setemailError('El correo no es válido')
            } else {
                setemailError(false)
            }
        }
        return (
            (!email ? true : (!email.match(EMAIL_RX)))
        )
    }

    const handleValidMail = () => {
        if (!haveErrors()) {
            setLoaderVisible(true);
            let payload = {
                event: identificadorEvento,
                user: email
            }
            WebinarService.validateEmail(payload).then(resp => {
                if (resp.status === 200) {
                    if (resp.data.status === 400) {
                        setemailError(resp.data.userMessage)
                    }
                    else if (resp.data.status === 200) {
                        secureStorage.setItem("userWebinarIframe", resp.data.data);
                        window.location.href = homeLink + "academia-tena/eventos/" + props.slug + "ver-webinar/";
                    }
                }
                setLoaderVisible(false);
            })
                .catch(err => { console.log(err); setLoaderVisible(false); })
        }
    }

    const whatsappElement = (copy) => {
        return (
            <a className={isWomenWebinar ? "f-webinar-form-whatsapp f-webinar-form-whatsapp--women" : "f-webinar-form-whatsapp"} href={'https://wa.me/' + redireccionWhatsApp.slice(1, redireccionWhatsApp.length)} rel="noopener noreferrer" target="_blank">
                <img
                    className="f-webinar-whatsapp-icon"
                    src={wpIco}
                    alt='Ícono whatsapp'
                />
                <div className="f-webinar-form-whatsapp-title">
                    {copy ? copy : '¿Necesitas ayuda?'}
                </div>
            </a>
        )
    }

    const step1 = (
        <div className={isSecondStyle ? "f-webinar-form__container--secondary" : "f-webinar-form__container"}>
            <div className="f-webinar-form__header f-webinar-header-1">
                {informacionInscripcionConferencia ?
                    <RichText 
                        jsonInfo={informacionInscripcionConferencia?.json}
                    />
                    :
                    <>
                        <b>Inscríbete al evento de forma gratuita</b>
                        <p>
                            Para asistir al webinar es necesario que registres tus datos en el formulario para
                            enviarte toda la información referente al evento y los links de acceso.
                        </p>
                    </>
                }
                {!props.isMobile && whatsappElement('¿Necesitas ayuda con tu inscripción?')}
            </div>
            <LeafletForm
                setstepState={setstepState}
                identificadorEvento={identificadorEvento}
                isPY={isPY}
                isSecondStyle={isSecondStyle}
                pyInfo={pyInfo}
                isSecondStyle={isSecondStyle}
                profesiones={profesiones}
                isWomenWebinar={isWomenWebinar}
                webinarName={props.webinarName}
                checksAceptoDePoliticas={checksAceptoDePoliticas}
            />
            {props.isMobile && whatsappElement('¿Necesitas ayuda con tu inscripción?')}
        </div>
    )

    const step2 = (
        <div className={isSecondStyle ? "f-webinar-form__container--secondary" : "f-webinar-form__container"}>
            <div className="f-webinar-form__header f-webinar-header-2">
                {informacionInscripcionExitosa ?
                    <RichText
                        jsonInfo={informacionInscripcionExitosa?.json} 
                    />
                    :
                    <>
                        <p className="f-webinar-header-title">¡Inscripción exitosa!</p>
                        <p>
                            Muy pronto nos encontraremos nuevamente en un espacio virtual en el cual entenderemos por qué un cuerpo activo y una mente sana, nos ayudan a fortalecer nuestras emociones para vivir con bienestar. ¡Te esperamos el próximo <b>6 de octubre</b>  en nuestra conferencia virtual!
                        </p>
                    </>
                }

                {whatsappElement('¿Necesitas ayuda con tu Inscripción?')}
                <button className="f-succes-retry-button-again" onClick={() => {
                    setstepState('step1')
                    try {
                        dataLayer.push({
                            'event': 'ga_event_consultorio',
                            'category': 'Eventos :: Próximo evento',
                            'action': 'Click :: Realizar otro registro',
                            'label': '{{nombre del evento}}',
                            'value': ''
                        }
                        );
                    } catch (error) {
                        console.log("🚀 ~ file: form-webinar.jsx ~ line 173 ~ error", error)
                    }
                }}>
                    Realizar otra inscripción
                </button>

                {webinarStatus == 'En el Evento' &&
                    <button className="f-succes-retry-button" onClick={() => setstepState('stepInEvent')}>
                        Ingresa al Webinar
                    </button>
                }
            </div>
        </div>
    )

    const stepInEvent = (
        <div className={isSecondStyle ? "f-webinar-form__container--secondary" : "f-webinar-form__container"}>
            <div className="f-webinar-form__header f-webinar-header-general">
                {informacionInicioConferencia ? 
                    <RichText
                        jsonInfo={informacionInicioConferencia?.json} 
                    />
                    :
                    <>
                    <p className="f-webinar-header-title">Hoy es nuestra conferencia virtual</p>
                    <p>
                        Ingresa el correo electrónico con el que previamente 
                        realizaste tu registro y no te pierdas nuestro tema de hoy.
                    </p>
                    </>
            }
                <p>Si no te registraste, hazlo <a href={homeLink + "webinar/"} onClick={e => { e.preventDefault(); setstepState("step1") }}>aquí</a></p>
                {whatsappElement('¿Necesitas ayuda para ingresar?')}
            </div>

            <div className="f-webinar-form__login">
                <InputWebinar
                    label='Email'
                    placeholder='ejemplo@mail.com'
                    error={emailError}
                    onChange={e => setemail(e.replace(/ /g, ''))}
                    value={email}
                    isWomenWebinar={isWomenWebinar}
                />

                <button className="f-webinar-form__button" onClick={() => { !isLoaderVisible && handleValidMail() }}>
                    {isLoaderVisible ?
                        <Loader
                            type="Oval"
                            color="#fff"
                            height={40}
                            width={40}
                            className="f-loader-container"
                        />
                        :
                        "INGRESAR"
                    }
                </button>

            </div>
        </div>
    )

    const stepPostEvent = (
        <div className={isSecondStyle ? "f-webinar-form__container--secondary" : "f-webinar-form__container"}>
            <div className="f-webinar-form__header f-webinar-header-general">
                {informacionSolicitudCertificado ? 
                    <RichText
                        jsonInfo={informacionSolicitudCertificado?.json} 
                    />
                    :
                    <>
                        <b className="f-webinar-header-title">¡Solicita tu certificado!</b>
                        {webinarStatus === "Finalizado el Evento" ?
                            <p>
                                Si asististe al Webinar, descarga tú certificado de asistencia al evento. <br /> <br />
                                *Los datos que te solicitamos son necesarios para la descarga del diploma
                            </p>
                            :
                            <p>
                                Obtenlo de manera fácil después de cada conferencia. Solo deberás llenar los datos y lo recibirás vía e-mail. <br /> <br />
                                *Los datos que te solicitamos son necesarios para descargar tu diploma
                            </p>
                        }
                    </>
                }
                {whatsappElement('¿Necesitas ayuda para descargar el certificado?')}
            </div>
            <div className="f-webinar-form__login">
                <FormCodeVerification
                    isPY={isPY}
                    pyInfo={pyInfo}
                    setstepState={setstepState}
                    setuserInfoPreload={setuserInfoPreload}
                />
            </div>
        </div>
    )

    const stepLoyaltyForm = (
        <div className={isSecondStyle ? "f-webinar-form__container--secondary" : "f-webinar-form__container"}>
            <div className="f-webinar-form__header f-webinar-header-general">
                {informacionSolicitudCertificado ? 
                    <RichText
                        jsonInfo={informacionSolicitudCertificado?.json} 
                    />
                    :
                    <>
                        <b className="f-webinar-header-title">¡Solicita tu certificado!</b>
                        {webinarStatus === "Finalizado el Evento" ?
                            <p>
                                Si asististe al Webinar, descarga tú certificado de asistencia al evento. <br /> <br />
                                *Los datos que te solicitamos son necesarios para la descarga del diploma
                            </p>
                            :
                            <p>
                                Obtenlo de manera fácil después de cada conferencia. Solo deberás llenar los datos y lo recibirás vía e-mail. <br /> <br />
                                *Los datos que te solicitamos son necesarios para descargar tu diploma
                            </p>
                        }
                    </>
                }
                {whatsappElement('¿Necesitas ayuda para descargar el certificado?')}
            </div>
            <FormLoyalty
                userInfoPreload={userInfoPreload}
                setstepState={setstepState}
                webinarId={identificadorEvento}
                setModalAlertVisibility={setModalAlertVisibility}
                setModalAlertText={setModalAlertText}
                checksAceptoDePoliticas={checksAceptoDePoliticas}
            />
        </div>
    )

    const stepSuccessLoyalty = (
        <div className={isSecondStyle ? "f-webinar-form__container--secondary" : "f-webinar-form__container"}>
            <div className="f-webinar-form__header f-webinar-header-2">
                {informacionDescargaExitosa ? 
                    <RichText
                        jsonInfo={informacionDescargaExitosa?.json} 
                    />
                    :
                    <>
                        <p className="f-webinar-header-title">¡Descarga exitosa!</p>
                        <b>¡Felicitaciones!</b>
                        <p>
                            Tu certificado ha sido descargado, si no lo ves, vuélvelo {" "}
                        </p>
                    </>
                }
                <p>
                    <b className="f-retry-certificate-button" onClick={() => retrygetCertificate(identificadorEvento, userInfoPreload.userId)}>a descargar aquí</b>
                </p>
            </div>
            {whatsappElement('¿Necesitas ayuda para descargar el certificado?')}
        </div>
    )

    return (
        <>
            {stepState === 'step1' && step1}
            {stepState === 'step2' && step2}
            {stepState === 'stepInEvent' && stepInEvent}
            {stepState === 'stepPostEvent' && stepPostEvent}
            {stepState === 'stepLoyaltyForm' && userInfoPreload && stepLoyaltyForm}
            {stepState === 'stepSuccessLoyalty' && stepSuccessLoyalty}
            {isModalAlertVisible &&
                <GenericModalAlert
                    icon={errorIcon}
                    title="Lo sentimos"
                    description={modalAlertText}
                    handleAction={setModalAlertVisibility}
                    type="primary"
                />}
        </>
    )
}

export default FormWebinar
